export const getAddressPath = (ward) => {
  if (!ward) return "N/A";
  if (ward?.version === 1) {
    return [ward?.name, ward?.district?.name, ward?.district?.province?.name].filter(Boolean).join(", ");
  }
  return [ward?.name, ward?.province?.name].filter(Boolean).join(", ");
};
